(function($){
  $(function(){  
    
    // document.ready

    jQuery( ".gridItem-outer" )
      .on( "mouseover touchstart", function (e) {
        var changeImage = $(this).find('.gritItem-image-hover').attr("hoverimage");
        $(this).find('.gritItem-image-hover').attr("src", changeImage);
      })
      .on( "mouseout touchend", function (e) {
        var changeImage = $(this).find('.gritItem-image-hover').attr("baseimage");
        $(this).find('.gritItem-image-hover').attr("src", changeImage);
      })

    _learnq =  window._learnq || [];
    // end: document.ready
  });
  
})(jQuery);

  
function JM_AddToCart(addProduct, quantity, lineProperties) {
  let submitData = {
    quantity: quantity || 1,
    id: addProduct
  }
  if (lineProperties) {
    submitData.properties = lineProperties
  }
  
  jQuery.ajax({
    url: '/cart/add.js',
    type: "POST",
    dataType:'json',
    data: submitData,
    success: function(cartResult) {
      console.log("cartResult: ", cartResult);
      JM_RefreshCart();
      JM_Klaviyo_AddToCart(cartResult);
    },
    error: function(errorReponse){
      console.log("addToCart errorReponse: ", JSON.stringify(errorReponse));
    }
  });
}

async function JM_Klaviyo_AddToCart(cartResult) {
  let test = await _learnq.push(['track', 'Added to Cart', cartResult]);
}


async function JM_RefreshCart() {  
  let cartDetails = await JM_getCart();
  jQuery('.my-cart-link #item_count').text(cartDetails.item_count);

  // updateCartSidebar();
  
  // Shopify.getCart(function(cartDetails) {
  //   console.log("cartDetails: ", cartDetails);
  //   jQuery('.my-cart-link #item_count').text(cartDetails.item_count);
  // })
}


async function JM_getCart() {
  let getConfig = {
    method: 'GET', 
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  };
  try {
    const fetchResponse = await fetch('/cart.js', getConfig);
    if (fetchResponse.ok) {
      const jsonResponse = await fetchResponse.json();
      return jsonResponse;  
    } else {
      return {error: true, errorMessage: "JM_getCart errorReponse: An error has occured"};
    }
  } catch(error) {
    console.log("JM_getCart errorReponse: ", JSON.stringify(error));
    return {error: true, errorMessage: error};
  }
}

async function JM_getCartHTML() {
  try {
    const fetchResponse = await fetch('/cart');
    if (fetchResponse.ok) {
      const cartResponse = await fetchResponse.text();
      const parser = new DOMParser();
      return parser.parseFromString(cartResponse, 'text/html');
    } else {
      return {error: true, errorMessage: "JM_getCart errorReponse: An error has occured"};
    }
  } catch(error) {
    console.log("JM_getCart errorReponse: ", JSON.stringify(error));
    return {error: true, errorMessage: error};
  }
}


async function JM_UpdateCartQty(cartItemKey, newQty) {
  let postData = {
    updates: {
      [cartItemKey]: newQty
    }
  };
  let postConfig = {
    method: 'POST', 
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(postData) 
  };
  
  try {
    const fetchResponse = await fetch('/cart/update.js', postConfig);
    if (fetchResponse.ok) {
      const jsonResponse = await fetchResponse.json();
      return jsonResponse;  
    } else {
      return {error: true, errorMessage: "JM_UpdateCartQty errorReponse: An error has occured"};
    }
  } catch(error) {
    console.log("JM_UpdateCartQty errorReponse: ", JSON.stringify(error));
    return {error: true, errorMessage: error};
  }
}

async function JM_ApplyDiscountCodeToCart() {
  $event.preventDefault();
  window.location.replace(`/discount/${this.discount_code.code}?redirect=/cart`);
}



/**
 * CART PAGE & CART SIDEBAR HANDLERS
 **/
async function manageCartUpdate(cartItemKey, newQty) {
  openOverlayUpdating();
  
  console.log("manageCartUpdate: " + cartItemKey + " = " + newQty);
  const updateResponse = await JM_UpdateCartQty(cartItemKey, newQty);
  const cartResponseHTML = await JM_getCartHTML();

  
  const newCart = cartResponseHTML.documentElement.querySelector('#cartSection .container');
  const currentCart = document.querySelector('#cartSection .container');
  if (newCart != null && currentCart != null) currentCart.innerHTML = newCart.innerHTML; 
  
  closeOverlayUpdating();

  JM_RefreshCart();
}

document.addEventListener('click', function (event) {
  if (event.target.closest('.cartItem-quantity')) {
    event.preventDefault();
    let cartLine = event.target.closest('.cartItem-quantity');
    let cartItemKey = cartLine.getAttribute("lineItem_key");
    let cartItemQty = cartLine.querySelector('input.cartItem-quantityInput').value;
    
    if (event.target.closest('.cartItem-quantity-minus')) {
      manageCartUpdate(cartItemKey, +cartItemQty - 1);
    }

    if (event.target.closest('.cartItem-quantity-plus')) {
      manageCartUpdate(cartItemKey, +cartItemQty + 1)
    }

    if (event.target.closest('.cartItem-remove')) {
      manageCartUpdate(cartItemKey, 0)
    }
  }
}, false);

/**
 * END: CART PAGE & CART SIDEBAR HANDLERS
 **/
